import { Pipe } from '@angular/core';
import { highlight } from '@project/shared/utils/highlight/js/highlight';
/**
 * Higlights a search string within a given text.
 */
var HighLightPipe = /** @class */ (function () {
    function HighLightPipe() {
    }
    HighLightPipe.prototype.transform = function (text, search, modifier) {
        if (modifier === void 0) { modifier = ''; }
        return highlight(text, search, modifier);
    };
    HighLightPipe.decorators = [
        { type: Pipe, args: [{ name: 'highlight', pure: false },] }
    ];
    return HighLightPipe;
}());
export { HighLightPipe };
//# sourceMappingURL=highlight.pipe.js.map